import script from "./kv.vue?vue&type=script&setup=true&lang=js"
export * from "./kv.vue?vue&type=script&setup=true&lang=js"

import "./kv.vue?vue&type=style&index=0&id=79f75e6b&lang=scss"

const __exports__ = script;

export default __exports__